import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="page">
      <h1>Not found</h1>
      <Link to="/">Go home</Link>
    </div>
  );
}
